import { useAuthState } from 'contexts/AuthProvider';
import { useGetBlockProfilesQuery } from 'queries/profileBlock/useGetBlockProfilesQuery';
import { useMemo } from 'react';

export const useBlockProfiles = () => {
  const { isLoggedIn } = useAuthState();
  const { data: blockProfilesData } = useGetBlockProfilesQuery(isLoggedIn);
  return useMemo(() => new Set(blockProfilesData?.profileIds), [blockProfilesData]);
};
